<script>
  let className = null;
  export { className as class };
  export let description;

  const text = description ? description.split("{logo}") : [];
</script>

{#if text[0]}
  {@html text[0]}
{/if}
<img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/cfa_society_germany.png" alt="CFA Society Germany" title="CFA Society Germany" class={className} />
{#if text[1]} {@html text[1]} {/if}
